export function normalizeEmail(email: string) {
	return email.toLowerCase()
}

export function normalizePhone(phone: string) {
	return `55${phone}`
}
